module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_7.bb9d927b.gif";